module.exports = __webpack_public_path__ + "media/src/images/raffleCheckboxCheckmark--dark-318248fcd117068d25af5295accea6fa.svg";